<template>
  <TabsSection
    :id="item.fields.id"
    :color-mode="item.fields.theme"
    :title="item.fields.title"
    :tab-list-full-width="true"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.fields.id,
        fieldId: 'title'
      })
    "
    @tab-change="onTabChange"
  >
    <template v-if="item.fields.customContent" #headline>
      <MappedComponents :items="item.fields.customContent" />
    </template>
    <template #tab-list-additional-content>
      <LibRichTextRenderer
        v-if="item.fields.additionalContent"
        :rich-text="item.fields.additionalContent"
      >
      </LibRichTextRenderer>
    </template>
    <template #panels>
      <TabPanel
        v-for="({ fields, sys }, index) in item.fields.tabPanels"
        :key="sys?.id"
        :uid="sys.id"
        :title="fields.title"
        :active-on-init="
          route.query.activeTab ? route.query.activeTab === sys?.id : !index
        "
        v-bind="
          $ContentfulLivePreview.getProps({
            entryId: sys.id,
            fieldId: 'title'
          })
        "
      >
        <MappedComponents :items="fields.contentSlot" />
      </TabPanel>
    </template>
  </TabsSection>
</template>

<script setup lang="ts">
import { TabsSection, TabPanel } from '@hypercodestudio/basler-components';
import type { ITabSection } from '~~/lib/ContentfulService';
import { PRODUCT_LIST_EMBEDDED_IN_TAB } from '~~/lib/constants';

const { $ContentfulLivePreview } = useNuxtApp();
const router = useRouter();
const route = useRoute();

provide(PRODUCT_LIST_EMBEDDED_IN_TAB, true);

interface Props {
  item: ITabSection;
}
defineProps<Props>();

const onTabChange = (tab: { computedId: string }): void => {
  router.push({
    path: route.path,
    query: { ...route.query, activeTab: tab.computedId },
    hash: route.hash
  });
};
</script>
